import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PlatUserSealData } from '../models/staff/plat-user-seal-data.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OmUserPersonSealDataService extends RequestService<PlatUserSealData> {
  static PATH = '/om/user/person/sealData';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmUserPersonSealDataService.PATH, globalService.debugUrl);
  }
}
